import React from 'react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
export function FinalCta() {
  return <section className="bg-sand py-14 sm:py-20" data-id="element-139" data-mp="vghhfpe10dp0">
      <div className="mx-auto max-w-2xl px-5 text-center" data-id="element-140" data-mp="19ez3lioa9i4t">
        <p className="font-sans text-[0.64rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-141" data-mp="19gih51ik1f2w">
          Último paso
        </p>
        <h2 className="mt-3 font-display text-[1.35rem] font-bold uppercase leading-tight text-charcoal sm:text-[2rem]" data-id="element-142" data-mp="1jd535tmmac6i">
          Tu consultorio ya genera oportunidades.
          <span className="mt-1 block text-gold-deep" data-id="element-143" data-mp="1eds6yi9uvsr9">Ahora dejá de perderlas.</span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl font-sans text-[0.9rem] leading-relaxed text-charcoal/75 sm:text-base" data-id="element-144" data-mp="1t251rbx7j5k6">
          Cada mes pasan por tu consultorio consultas, turnos y presupuestos que podrían convertirse
          en tratamientos. La diferencia no está en trabajar más horas: está en cerrar las fugas.
        </p>
        <p className="mx-auto mt-2.5 max-w-xl font-sans text-[0.9rem] leading-relaxed text-charcoal/75 sm:text-base" data-id="element-145" data-mp="n5m6o3b5462e">
          Detectar, convertir, recuperar y rentabilizar. Cinco tomos para implementarlo paso a paso
          en el consultorio que ya tenés.
        </p>

        <PriceBlock className="mt-6" size="lg" data-id="element-146" data-mp="x2h40ivog0f3" />

        <div className="mt-5 flex justify-center" data-id="element-147" data-mp="123elsucrysg2">
          <CTAButton className="w-full max-w-[26rem] px-4 py-4" data-id="element-148" data-mp="120sd2re5e6w9" />
        </div>

        <p className="mt-3 font-sans text-[0.7rem] font-semibold uppercase tracking-[0.14em] text-charcoal/65" data-id="element-149" data-mp="163xf6subg6kd">
          Método Consultorio Rentable · 5 tomos + 5 recursos extra
        </p>
        <p className="mt-1 font-sans text-[0.72rem] text-charcoal/55" data-id="element-150" data-mp="1fvl0ec0a4rde">
          Pago seguro · Garantía 7 días
        </p>
      </div>
    </section>;
}